import React from 'react';
import cn from 'classnames';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';
import type { InputSize } from './types';
import styles from './input.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IProps {
  appendComponent: React.ReactElement | React.ElementType | React.FC<any>,
  isClearIconVisible: boolean,
  isCustomIconVisible: boolean,
  clear: () => void,
  icon?: IconComponentType,
  iconClassName?: string,
  size?: InputSize,
}

const InputAppend = ({
  appendComponent: AppendComponent,
  isClearIconVisible,
  isCustomIconVisible,
  clear,
  icon: Icon,
  iconClassName,
  size,
}: IProps) => {
  return (
    <div className={ cn(styles.appendComponent, size && styles[`size${ size }`]) }>
      { /* eslint-disable-next-line no-nested-ternary */ }
      { AppendComponent ? (
        React.isValidElement(AppendComponent) ? (
          AppendComponent
        ) : (
          // @ts-ignore
          <AppendComponent />
        )
      ) : (
        <>
          { isClearIconVisible ? (
            <IconButton
              icon={ <IconClose /> }
              className={ cn(styles.clearableBtn, size && styles[`size${ size }`]) }
              onClick={ clear }
              dataTest="iconClose"
              ariaLabel="Clear input"
            />
          ) : (
            <>
              { isCustomIconVisible && (
                <div className={ cn(styles.iconPositionRight, size && styles[`size${ size }`]) }>
                  <Icon className={ iconClassName } />
                </div>
              ) }
            </>
          ) }
        </>
      ) }
    </div>
  );
};

export default React.memo(InputAppend);
